"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNavOption = exports.SubNavOptionsWrapper = exports.SubNavHeader = exports.SubNavPadding = exports.SubNav = exports.MenuLabel = exports.MenuOption = exports.Menu = exports.MenuWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

var _PrimaryText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PrimaryText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var MenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "SideNavstyles__MenuWrapper",
  componentId: "sc-4c4aqd-0"
})(["height:100%;position:relative;width:", ";z-index:", ";"], function (props) {
  return props.theme.sideNavWidth;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('-', props.theme.menu, 1);
});

exports.MenuWrapper = MenuWrapper;

var Menu = _styledComponents.default.div.withConfig({
  displayName: "SideNavstyles__Menu",
  componentId: "sc-4c4aqd-1"
})(["align-items:center;background-color:", ";display:flex;flex-direction:column;height:100%;left:0;padding:", " 0;position:absolute;top:0;width:", ";"], function (props) {
  return props.theme.c_side_nav;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.sideNavWidth;
});

exports.Menu = Menu;

var MenuOption = _styledComponents.default.button.withConfig({
  displayName: "SideNavstyles__MenuOption",
  componentId: "sc-4c4aqd-2"
})(["align-items:center;border-radius:", ";cursor:pointer;display:flex;flex-direction:column;margin:.25rem 0;outline:none;padding:", " 0;width:", ";", ";&:hover{background-color:", ";}"], function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', props.theme.standardPadding, 2);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('-', props.theme.sideNavWidth, 1);
}, function (props) {
  return props.active ? "background-color: ".concat(props.theme.c_side_nav_hover) : '';
}, function (props) {
  return props.theme.c_side_nav_active;
});

exports.MenuOption = MenuOption;
var MenuLabel = (0, _styledComponents.default)(_PrimaryText.default).withConfig({
  displayName: "SideNavstyles__MenuLabel",
  componentId: "sc-4c4aqd-3"
})(["font-size:", ";font-weight:", ";line-height:1.4;padding:", " 0 0 0;"], function (props) {
  return props.theme.fontInitial;
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.standardPadding;
});
exports.MenuLabel = MenuLabel;

var SubNav = _styledComponents.default.div.withConfig({
  displayName: "SideNavstyles__SubNav",
  componentId: "sc-4c4aqd-4"
})(["background-color:", ";box-shadow:", ";display:flex;flex-direction:column;height:100%;left:", ";overflow:hidden;position:absolute;top:0;width:", ";white-space:nowrap;transition:.3s width;transition-timing-function:ease-in-out;"], function (props) {
  return props.theme.c_side_nav_sub;
}, function (props) {
  return props.theme.s_card;
}, function (props) {
  return props.theme.sideNavWidth;
}, function (props) {
  return props.isOpen ? props.theme.subNavWidth : 0;
});

exports.SubNav = SubNav;

var SubNavPadding = _styledComponents.default.div.withConfig({
  displayName: "SideNavstyles__SubNavPadding",
  componentId: "sc-4c4aqd-5"
})(["padding:", ";"], function (props) {
  return props.theme.standardPadding;
});

exports.SubNavPadding = SubNavPadding;

var SubNavHeader = _styledComponents.default.div.withConfig({
  displayName: "SideNavstyles__SubNavHeader",
  componentId: "sc-4c4aqd-6"
})(["padding:", ";"], function (props) {
  return props.theme.standardPadding;
});

exports.SubNavHeader = SubNavHeader;

var SubNavOptionsWrapper = _styledComponents.default.div.withConfig({
  displayName: "SideNavstyles__SubNavOptionsWrapper",
  componentId: "sc-4c4aqd-7"
})(["display:flex;flex-direction:column;"]);

exports.SubNavOptionsWrapper = SubNavOptionsWrapper;

var SubNavOption = _styledComponents.default.button.withConfig({
  displayName: "SideNavstyles__SubNavOption",
  componentId: "sc-4c4aqd-8"
})(["border-radius:", ";color:", ";cursor:pointer;font-size:", ";font-weight:", ";line-height:1;margin:", " 0 0 0;outline:none;padding:", ";position:relative;text-align:left;", ";&:hover{background-color:", ";}"], function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.c_side_nav_sub_text;
}, function (props) {
  return props.theme.fontInitial;
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.active ? "background-color: ".concat(props.theme.c_side_nav_sub_active) : '';
}, function (props) {
  return props.theme.c_side_nav_sub_hover;
});

exports.SubNavOption = SubNavOption;